export const OVERVIEW = 1;
export const SUBTITLE = 2;
export const DISPERSION = 3;
export const PROGRESS = 4;
export const TREND = 5;
